import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { FC } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

const sliderImagesUrls = [
  "https://erp.webcom.group/img/newLogin/background/1.jpg",
  "https://erp.webcom.group/img/newLogin/background/2.jpg",
  "https://erp.webcom.group/img/newLogin/background/3.jpg",
  "https://erp.webcom.group/img/newLogin/background/6.jpg",
  "https://erp.webcom.group/img/newLogin/background/8.jpg",
];

const StyledSwiper = styled(Swiper)({
  width: "100vw",
  height: "100vh",
  position: "absolute",
  top: 0,
  left: 0,
});

export interface ISignInSliderProps {
  isBlur: boolean;
}
export const SignInSlider: FC<ISignInSliderProps> = ({ isBlur }) => {
  return (
    <StyledSwiper spaceBetween={10} slidesPerView={1} loop>
      {sliderImagesUrls.map((url) => (
        <SwiperSlide key={url}>
          <Box
            component="img"
            src={url}
            sx={{
              objectFit: "cover",
              width: " 100%",
              height: "100%",
              filter: `brightness(${isBlur ? "40%" : ""})`,
            }}
          />
        </SwiperSlide>
      ))}
    </StyledSwiper>
  );
};
